<script>
import { mapActions, mapGetters } from 'vuex'
import FilterInputGenderMobile from '@/components/pages/tutor-list/filter/filter-input/filter-input-gender-mobile.vue'
export default {
  name: 'FilterInputMobile',
  components: { FilterInputGenderMobile },
  computed: {
    ...mapGetters('dialog', ['allDialogs']),
    name () {
      return this.allDialogs?.MOBILE_FILTER_TUTOR_LIST
    }
  },
  methods: {
    ...mapActions('dialog', ['showDialog']),
    updateData () {
      this.$refs[this.name].hide()
      setTimeout(() => {
        this.$nuxt.$emit('fetchList')
      }, 500)
    },
    showFilterDialog () {
      this.showDialog(this.allDialogs?.MOBILE_FILTER_TUTOR_LIST)
    }
  }
}
</script>

<template>
  <div class="filter-input-mobile">
    <div class="filter-input-mobile__btn" @click="showFilterDialog">
      <BaseIcon name="sort" />
    </div>
    <BaseDialog
      :ref="name"
      width="lg"
      height="fixed"
      mobile-height="full"
      :name="name"
      class="review-dialog"
      title-header="Filters"
    >
      <template #body>
        <div class="mt-4">
          <FilterInputGenderMobile platform="mobile" :emit-response="true" />
        </div>
      </template>
      <template #footer>
        <div class="container py-4 shadow-banner">
          <BaseButton class="w-full" :label="$t('actions.apply_filter')" @click="updateData" />
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped lang="scss">
.filter-input-mobile {
  @apply mt-8;
  &__btn {
    @apply w-12 h-12 flex justify-center items-center rounded-2xl border border-primary
    cursor-pointer;
  }
}
</style>
